<script>
import { createEventDispatcher } from "svelte"
import { createSearchService } from "../Service/SearchService"
import LocationCard from "./LocationCard.svelte"


// props
export let locations = []

// vars
let query = '' // bound to input
const Events = {
	SearchQuery: 'search-query',
	SearchCancel: 'search-cancel',
}
const dispatch = createEventDispatcher()
const searchsvc = createSearchService( locations, [
	{ name: 'city.title', weight: 1 },
	{ name: 'state.title', weight: .3 },
	{ name: 'title', weight: .8 },
] )


// event handlers
const onInput = e => {
	dispatch( Events.SearchQuery, { query } )
}

const onCancel = e => {
	dispatch( Events.SearchCancel )
	results = []
	query = ''
}

const onSearch = e => {
	dispatch( Events.SearchQuery, { query } )
}

// reactives
$: isSearching = query.trim() !== ''
$: results = query.trim() !== '' ? searchsvc.search( query ) : []
</script>

<div class="location-search location-search--keyword">

	<div class="location-search__ctrl">
		<input
			class="location-search__query"
			type="text" placeholder="Search"
			bind:value={query}
			on:input={onInput}
		/>
		{#if isSearching}
			<button type="button" class="location-search__cancel" on:click={onCancel} >cancel</button>
		{:else}
			<button type="button" class="location-search__search" on:click={onSearch}>search</button>
		{/if}
	</div>

	{#if results.length}
		<div class="location-search__results">
			{#each results as location}
				<LocationCard {location}/>
			{/each}
		</div>
	{/if}
</div>
